import {
  VOUCHER_TRANSACTION_SUCCESS,
  VOUCHER_TRANSACTION_FAILED,
  RESET_VOUCHER_TRANSACTION,
  LOADING_VOUCHER_TRANSACTION,
  NETWORK_ERROR_VOUCHER_TRANSACTION,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  data: {},
  networkError: "",
  invalidRequest: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_VOUCHER_TRANSACTION: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case VOUCHER_TRANSACTION_FAILED: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case VOUCHER_TRANSACTION_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case NETWORK_ERROR_VOUCHER_TRANSACTION: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: true,
        data: {},
      };
    }
    case RESET_VOUCHER_TRANSACTION: {
      return (state = initialState);
    }

    default:
      return state;
  }
};
